"use strict";

import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import { withCarouselNav, syncCarouselNavVisibility } from './carousel-nav';

const SELECTOR = '[data-product-carousel]';

function getCarouselSpaceBetween() {
	return parseFloat(getComputedStyle(document.documentElement).fontSize) * 5;
}

function initProductDescriptionCarousel() {
	const spaceBetween = getCarouselSpaceBetween();

	document.querySelectorAll(SELECTOR).forEach(function (el) {
		if (el.swiper) {
			return;
		}

		const swiper = new Swiper(el, withCarouselNav(el, {
			modules: [FreeMode],
			slidesPerView: 'auto',
			spaceBetween,
			grabCursor: true,
			freeMode: {
				enabled: true,
				momentumRatio: 0.85,
				momentumVelocityRatio: 0.85,
			},
		}));

		syncCarouselNavVisibility(swiper);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initProductDescriptionCarousel, { once: true });
} else {
	initProductDescriptionCarousel();
}
